export const company = {
  name: "RC Mobility Executive Service",
  phone: "(19) 98116-1349",
  phoneRaw: "5519981161349",
  email: "rcmobilitytransporte@gmail.com",
  location: "Campinas, São Paulo",
  hours: "Atendimento horário comercial e plantão emergencial 24h",
  instagram: "https://www.instagram.com/rc_mobility/",
};

export const services = [
  { title: "Transfer para aeroportos", short: "Chegadas e partidas com monitoramento, recepção e pontualidade.", image: "/images/fleet/fleet-01.webp", icon: "plane" },
  { title: "Transporte executivo", short: "Mobilidade corporativa discreta para agendas, reuniões e compromissos.", image: "/images/fleet/fleet-02.webp", icon: "briefcase" },
  { title: "Eventos corporativos", short: "Logística coordenada para convidados, equipes e lideranças.", image: "/images/fleet/fleet-04.webp", icon: "calendar" },
  { title: "Vans executivas", short: "Conforto e organização para grupos, delegações e equipes.", image: "/images/fleet/fleet-12.webp", icon: "van" },
  { title: "Motorista à disposição", short: "Atendimento dedicado pelo período que sua agenda exigir.", image: "/images/fleet/fleet-10.webp", icon: "clock" },
  { title: "Viagens e city tours", short: "Roteiros personalizados com tranquilidade, privacidade e segurança.", image: "/images/fleet/fleet-14.webp", icon: "map" },
];

export const fleetImages = Array.from({ length: 14 }, (_, index) => ({
  src: `/images/fleet/fleet-${String(index + 1).padStart(2, "0")}.webp`,
  alt: index > 10
    ? "Van executiva da frota RC Mobility preparada para transporte de grupos"
    : "Veículo premium da frota RC Mobility para transporte executivo em Campinas",
}));

export const journalImages = Array.from({ length: 15 }, (_, index) => ({
  src: `/images/journal/journal-${String(index + 1).padStart(2, "0")}.webp`,
  alt: `RC Mobility: excelência, segurança e mobilidade executiva — publicação ${index + 1}`,
}));

export const clients = ["S Cosméticos do Bem", "Porto", "Ornare", "Azul Seguros", "Selecta", "Ativy"];

export const serviceOptions = [
  "Transfer para aeroporto", "Transporte executivo", "Evento corporativo",
  "Van executiva", "Motorista à disposição", "Viagem ou city tour", "Outro serviço",
];
